/* eslint-disable */

(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('responsavelAprovacao', ResponsavelAprovacao);

  ResponsavelAprovacao.$inject = [
    'UsuariosService',
    '$rootScope',
    'StorageService'
  ];

  function ResponsavelAprovacao(UsuariosService, $rootScope, StorageService) {
    var directive = {
      templateUrl: 'views/directives/responsavel_aprovacao.html',
      restrict: 'AE',
      scope: {
        propriedade: '=',
        tipo: '@'
      },
      link: function(scope) {
        scope.loading = true;
        scope.responsaveis = [];

        var scopedPropriedade = $rootScope.propriedades.find(function(propriedade) {
          return propriedade.id === scope.propriedade.id;
        }) || {};

        const cacheKey = `responsaveis_aprovacao_${ scope.propriedade.id }_${ scope.tipo}`;
        const shouldLoad = !scopedPropriedade.responsaveis || !scopedPropriedade.responsaveis[scope.tipo];
        const cachedValue = StorageService.get(cacheKey) || {};
        const emptyCache = Object.keys(cachedValue).length === 0;

        if (!emptyCache && shouldLoad) {
          scopedPropriedade.responsaveis = cachedValue.responsaveis;
          scope.loading = false;
        }

        if (shouldLoad && emptyCache) {
          scopedPropriedade.responsaveis = scopedPropriedade.responsaveis || {};
          scopedPropriedade.responsaveis[scope.tipo] = scopedPropriedade.responsaveis[scope.tipo] || [];
          scopedPropriedade.responsaveisPromise = UsuariosService.listResponsaveisAprovacao(scope.propriedade.id, scope.tipo).then(function(response) {
            scopedPropriedade.responsaveis[scope.tipo] = scope.responsaveis = response.data;
          })
            .catch(function(error) {
              console.error('Erro ao carregar responsáveis', error);
            })
            .finally(function() {
              StorageService.set(cacheKey, { responsaveis: scopedPropriedade.responsaveis });
              scope.loading = false;
            });
        } else {
          scope.responsaveis = (cachedValue.responsaveis || {})[scope.tipo] || [];

          if (scope.responsaveis.length === 0 && scopedPropriedade.responsaveisPromise) {
            scopedPropriedade.responsaveisPromise.then(function() {
              scope.responsaveis = scopedPropriedade.responsaveis[scope.tipo];
            });
          }

          scope.loading = false;
        }

        scope.joinedNames = function() {
          return scope.responsaveis.reduce(function(group, responsavel, index) {
            if (index % 4 === 0) {
              group.push('<br>' + responsavel.nome_completo);
            } else {
              group.push(responsavel.nome_completo);
            }
            return group;
          }, []).join(', ');
        };
      }
    };

    return directive;
  }
}());
